package one.healthium.today.ui.models

import one.healthium.log_period.domain.PeriodPhase

data class PeriodTrackerUiModel(
    val phase: PeriodPhaseUiModel = PeriodPhaseUiModel(),
    val tipText: String? = null,
) {
    fun statusText(): String? {
        if (phase.phase == PeriodPhase.UNDEFINED) {
            return "Log the first day of your last period to start"
        }
        val cycleDay = phase.cycleDay ?: return null
        val duration = phase.duration ?: return null
        if (cycleDay - duration >0 ) {
            val delay = cycleDay - duration
            return "Your period is ${delay} day${if (delay%10 == 1) "s" else ""} late"
        } else if (duration - cycleDay <= 5) {
            val ahead = duration - cycleDay
            return "Predicted period is in ${ahead} day${if (ahead%10 == 1) "s" else ""}"
        } else {
            return null
        }
    }

    fun dayText(): String? {
        if (phase.phase == PeriodPhase.UNDEFINED || statusText() != null) {
            return null
        }
        return phase.cycleDay?.let { "Day $it" }
    }

    fun logButtonText(): String {
        return  when (phase.phase) {
            PeriodPhase.UNDEFINED -> "Log it >"
            else -> "Log Period >"
        }
    }

}

data class PeriodPhaseUiModel(
    val phase: PeriodPhase = PeriodPhase.UNDEFINED,
    val cycleDay: Int? = null,
    val duration: Int? = null,
)
